<template>
<h1 class="text-center">Tooltips</h1>
</template>

<script>
export default {
  name: "Tooltips"
}
</script>

<style scoped>

</style>